export class EntAgroculturalCooperativeFilter {

  page: number;
  size: number;
  name: string | null;
  deleted: boolean;

  constructor(init?:Partial<EntAgroculturalCooperativeFilter>) {
    this.deleted = false;
    this.name = null;
    this.page = 1;
    this.size = 30;
    if(init){
      Object.assign(this, init)
    }
  }
}
